import React from 'react';

import { IOption, Option, SubMenuOption } from './interfaces';
import { Location } from 'react-router';
import { membersMenuOptions } from './menu-options/management/members';
import { competitionMenuOptions } from './menu-options/management/competitions';
import { newsMenuOptions } from './menu-options/management/news';
import { associationMenuOptions } from './menu-options/management/association';
import { rolesAndPermissionsMenuOptions } from './menu-options/management/roles-and-permissions';
import { myProfileMenuOptions } from './menu-options/my-profile';
import { mainMenuOptions } from './menu-options/main-menu';
import { translate } from '@translations/i18n';
import { ISubMenuOption } from './components/SubMenu/interfaces';

const injectLabels = (
  options: Option[],
  menuType: string = 'mainMenu'
): IOption[] => {
  return options.map((option) => {
    return {
      ...option,
      label: translate(`sidebar:${menuType}.${option.key}.label`),
      subItems: option.subItems
        ? injectSubMenuLabels(option.subItems, `${menuType}.${option.key}`)
        : null,
    } as IOption;
  });
};

const injectSubMenuLabels = (
  options: SubMenuOption[],
  menuOptionKey: string
): ISubMenuOption[] => {
  return options.map((option) => {
    return {
      ...option,
      label: translate(
        `sidebar:${menuOptionKey}.subMenuItems.${option.key}.label`
      ),
    } as ISubMenuOption;
  });
};

const filterOptionsByDevMode = (
  options: Option[],
  devMode: boolean
): Option[] => {
  return options
    .map((option) => {
      if (option.subItems) {
        const subItems = option.subItems.filter(
          (subItem) => devMode || subItem.inProduction
        );

        if (subItems.length === 0) {
          return null;
        }

        return { ...option, subItems };
      }

      if (devMode || option.inProduction) {
        return option;
      }

      return null;
    })
    .filter((option): option is Option => option !== null);
};

export const getMenuOptionsBasedOnLocation = (
  location: Location,
  devMode: boolean
): IOption[] => {
  if (location.pathname.startsWith('/manage/members/')) {
    return injectLabels(
      filterOptionsByDevMode(membersMenuOptions, devMode),
      'modules.members'
    );
  } else if (location.pathname.startsWith('/manage/competitions/')) {
    return injectLabels(
      filterOptionsByDevMode(competitionMenuOptions, devMode),
      'modules.competitions'
    );
  } else if (location.pathname.startsWith('/manage/news/')) {
    return injectLabels(
      filterOptionsByDevMode(newsMenuOptions, devMode),
      'modules.news'
    );
  } else if (location.pathname.startsWith('/manage/association/')) {
    return injectLabels(
      filterOptionsByDevMode(associationMenuOptions, devMode),
      'modules.association'
    );
  } else if (location.pathname.startsWith('/manage/roles-and-permissions')) {
    return injectLabels(
      filterOptionsByDevMode(rolesAndPermissionsMenuOptions, devMode),
      'modules.rolesAndPermissions'
    );
  } else if (location.pathname.startsWith('/profile')) {
    return injectLabels(
      filterOptionsByDevMode(myProfileMenuOptions, devMode),
      'modules.myProfile'
    );
  }

  return injectLabels(filterOptionsByDevMode(mainMenuOptions, devMode));
};
